'use strict';

import reducer from './reducers';

import * as usersOperations from './operations';
import * as usersSelectors from './selectors';

export {
	usersOperations,
	usersSelectors
};

export default reducer;
